import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import UnlockSection from "./Components/UnlockSection";
import useCheckPermission from "../../hooks/useCheckPermission";
import UnauthorizedAccess from "./Components/UnauthorizedAccess";

const ProtectedRoute = ({ route }) => {
  const isAuthenticated = useSelector((state) => state.login.isAuthenticated);
  const masterAuthToken = useSelector((state) => state.login.masterAuthToken);
  const location = useLocation();
  const isAllowed = useCheckPermission(route.key, "VIEW");

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if(!isAllowed) {
    return (
      <UnauthorizedAccess />
    )
  }

  if(route.isSecured && !masterAuthToken) {
    return (
      <UnlockSection />
    )
  }

  return route.component;
};

export default ProtectedRoute;
